const ownerSymbol = Symbol("e308.definition-owner");
export function owned(value, owner) {
    Object.defineProperty(value, ownerSymbol, { enumerable: false, value: owner });
    return Object.freeze(value);
}
export function ownerOf(value) {
    return value[ownerSymbol];
}
//# sourceMappingURL=handles.js.map